import { createFileRoute } from '@tanstack/react-router'
import AddTaskForm from '@/features/tasks/components/AddTaskForm'

interface TaskNewSearch {
  assetId?: string
  projectId?: string
  planId?: string
  title?: string
  description?: string
  priority?: string
  rrule?: string
}

export const Route = createFileRoute('/_authed/tasks/new/')({
  component: NewTaskRoute,
  validateSearch: (search: Record<string, unknown>): TaskNewSearch => ({
    assetId: search.assetId as string | undefined,
    projectId: search.projectId as string | undefined,
    planId: search.planId as string | undefined,
    title: search.title as string | undefined,
    description: search.description as string | undefined,
    priority: search.priority as string | undefined,
    rrule: search.rrule as string | undefined,
  }),
})

function NewTaskRoute() {
  const search = Route.useSearch()
  return (
    <AddTaskForm
      assetId={search.assetId}
      projectId={search.projectId}
      planId={search.planId}
      title={search.title}
      description={search.description}
      priority={search.priority}
      rrule={search.rrule}
    />
  )
}
